import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sxDarkGreyBody, sxTitle } from '../../../../assets/styles/CommonSxProps';
import LoadingApp from '../../../../components/LoadingApp';
import ModalFeedBack from '../../../../components/ModalFeedBack';
import { Address } from '../../../../interfaces/entities/Cancelamento/PassoCartaCancelamento/Address';
import { EnderecoCancelamento } from '../../../../interfaces/entities/Cancelamento/PassoCartaCancelamento/EnderecoCancelamento';
import { PassoCartaCancelamento } from '../../../../interfaces/entities/Cancelamento/PassoCartaCancelamento/PassoCartaCancelamento';
import { EnderComunicCancelamento } from '../../../../interfaces/entities/Cancelamento/PassoMotivoCancelamento/EnderComunicCancelamento';
import { PassoAceiteTermo } from '../../../../interfaces/entities/Cancelamento/PassoMotivoCancelamento/PassoAceiteTermo';
import { PassoMotivoCancelamento } from '../../../../interfaces/entities/Cancelamento/PassoMotivoCancelamento/PassoMotivoCancelamento';
import { Contrato } from '../../../../interfaces/entities/Cancelamento/PassoSelecioneBeneficiarios/Contrato';
import { CancellationStepsEnum } from '../../../../interfaces/enum/CancellationStepsEnum';
import { passoAceiteTermo, passoFinalizacao, passoFormaEnvioConfirmacao, passoMotivoCancelamento } from '../../../../services/ContratoService';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import EnviarEmail from '../EnviarEmail';
import EnviarRetencao from '../EnviarRetencao';
import StepBeneficiarios from './StepBeneficiarios';
import StepCartaCancelamento from './StepCartaCancelamento';
import StepFinalizacao from './StepFinalizacao';
import StepMotivoCancelamento from './StepMotivoCancelamento';
import StepTermos from './StepTermos';
import './styles.css';
import DefaultTabs from '../../../../components/Accessibility/DefaultTabs';
import PageTitle from '../../../../components/Accessibility/PageTitle';

const SolicitacaoCancelamento: React.FC = () => {

  const [loading, setLoading] = useState<boolean>(false);
  const [currentStep, setCurrentStep] = useState<CancellationStepsEnum>(CancellationStepsEnum.Motivo);
  const [isPermissao, setIsPermissao] = useState<boolean>(false);
  const [motivoSelecionado, setMotivoSelecionado] = useState<string>('');
  const [motivosCancelamento, setMotivosCancelamento] = useState<PassoMotivoCancelamento>();
  const [indCancelContr, setIndCancelContr] = useState<boolean>(false);
  const [passoCartaCancelamento, setPassoCartaCancelamento] = useState<PassoCartaCancelamento>();
  const [cancellationTerms, setCancellationTerms] = useState<PassoAceiteTermo>();
  const [isCancellationEmail, setIsCancellationEmail] = useState<boolean>(false);
  const [isRetencao, setIsRetencao] = useState<boolean>(false);
  const [formaEnvioSelecionada, setFormaEnvioSelecionada] = useState<string>();
  const [benefsToCancel, setBenefsToCancel] = useState<Contrato[]>([]);
  const [protocoloCancelamento, setProtocoloCancelamento] = useState<string>('');
  const [tipoCancelamento, setTipoCancelamento] = useState<string>('');
  const navigate = useNavigate();
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const { textStyleAccessibility, fontSizeTitleStyleAccessibility, contrastBorderAccessibility, contrastStyle } = useAccessibility();

  useEffect(() => {
    fetchMotivosCancelamento('');
  }, []);

  const fetchMotivosCancelamento = async (tipoCancel: string) => {
    setLoading(true);
    const response = await passoMotivoCancelamento(tipoCancel);
    if (response?.status === 200) {
      setTipoCancelamento(response.data.tipoCancelamento)
      const passoMotivoCancelamento: PassoMotivoCancelamento = response.data;
      permissionValidate(passoMotivoCancelamento);
    } else {
      const errorMessage = !!response?.data.mensagem ? response.data.mensagem : 'Tente novamente em instantes';
      openModal('Erro ao obter motivos para cancelamento', errorMessage, handleCloseModalFeedback, handleCloseModalFeedback, 'Fechar');
      console.error(response);
    }
    setLoading(false);
  }

  const fetchFormaEnvioConfirmacao = async (benefsToCancel: Contrato[]) => {
    setLoading(true);
    const response = await passoFormaEnvioConfirmacao(motivoSelecionado, benefsToCancel, tipoCancelamento);
    if (response?.status === 200 && response?.data?.validationError?.listaInfo?.length) {
      const errorMsg = response?.data?.validationError?.listaInfo[0].mensagem;
      openModal('Erro ao prosseguir no processo de cancelamento', errorMsg, handleCloseModalFeedback, handleCloseModalFeedback, 'Fechar', true);
    } else if (response?.status === 200) {
      const passoCartaCancelamento: PassoCartaCancelamento = response.data;
      checkRetencao(passoCartaCancelamento);
      setPassoCartaCancelamento(passoCartaCancelamento);
      nextStep();
    } else {
      const errorMessage = !!response?.data.mensagem ? response.data.mensagem : 'Tente novamente em instantes';
      openModal('Erro', errorMessage, handleCloseModalFeedback, handleCloseModalFeedback, 'Fechar');
      console.error(response);
    }
    setLoading(false);
  }

  const checkRetencao = (passoCartaCancelamento: PassoCartaCancelamento) => {
    if (passoCartaCancelamento.bloquearCancelamento) {
      setCurrentStep(CancellationStepsEnum.Finalizacao);
      setIsRetencao(true);
      setIsCancellationEmail(false);
    }
  }

  const permissionValidate = (passoMotivoCancelamento: PassoMotivoCancelamento) => {
    setIsPermissao(passoMotivoCancelamento.isPermissao);
    if (!passoMotivoCancelamento.isPermissao) {
      openModal('Operação inválida', 'Você não tem permissão para acessar este módulo.', goToHome, goToHome, 'Voltar ao início');
    } else {
      setMotivosCancelamento(passoMotivoCancelamento);
    }
  }

  const fetchTermoCancelamento = async (email?: string, postal?: Address | {}) => {
    setLoading(true);
    const response = await passoAceiteTermo(email, postal);
    if (response?.status === 200) {
      setCancellationTerms(response.data);
      nextStep();
    } else {
      const errorMessage = !!response?.data.mensagem ? response.data.mensagem : 'Tente novamente em instantes';
      openModal('Erro ao obter motivos para cancelamento', errorMessage, handleCloseModalFeedback, handleCloseModalFeedback, 'Fechar');
      console.error(response);
    }
    setLoading(false);
  }

  const cancellationSteps = [
    { value: CancellationStepsEnum.Motivo, label: 'Motivo' },
    { value: CancellationStepsEnum.Beneficiarios, label: 'Beneficiário(s)' },
    { value: CancellationStepsEnum.CartaCancelamento, label: 'Carta de cancelamento' },
    { value: CancellationStepsEnum.Termos, label: 'Termos' },
    { value: CancellationStepsEnum.Finalizacao, label: 'Finalização' },
  ]

  const openModal = (
    title: string,
    subtitle: string,
    closeAction: () => void,
    buttonAction: () => void,
    buttonText: string,
    warning?: boolean,
  ) => {
    setModalFeedback({
      icon: warning ? 'warning' : 'error',
      title: title,
      subTitle: subtitle,
      textButton: buttonText,
      showButtonModal: true,
      closeAction: closeAction,
      buttonAction: buttonAction
    });
  }

  const handleCloseModalFeedback = () => {
    setModalFeedback(null);
  }

  const goToHome = () => {
    navigate('/home');
  }

  const nextStep = () => {
    setCurrentStep((current) => {
      const next = current + 1;
      if (Object.values(CancellationStepsEnum).includes(next)) {
        return next;
      } else {
        return current;
      }
    });
  };

  const backStep = () => {
    const backStep = currentStep - 1;
    if (Object.values(CancellationStepsEnum).includes(backStep)) {
      return setCurrentStep(backStep);
    } else {
      navigate('/meuPlano/cancelamento');
    }
  };

  const onTabClicked = (index: number) => {
    if (currentStep === CancellationStepsEnum.Finalizacao && isCancellationEmail) {
      return backToFirstStep();
    }
    const backStep = index + 1;
    if (Object.values(CancellationStepsEnum).includes(backStep)) {
      return setCurrentStep(backStep);
    } else {
      navigate('/meuPlano/cancelamento');
    }
  }

  const goToEmailStep = () => {
    setCurrentStep(CancellationStepsEnum.Finalizacao);
    setIsCancellationEmail(true);
    setIsRetencao(false);
  }

  const handleProceedFirstStep = () => {
    // if (motivoSelecionado === 'INSATI' || motivoSelecionado === 'TRCOPF' || motivoSelecionado === 'FINANC') {
    //   goToEmailStep();
    //   return;
    // }
    nextStep();
  }

  const handlebenefsToCancel = (benefs: Contrato[]) => {
    setBenefsToCancel(benefs);
  }

  const handleProceedSecondStep = (benefs: Contrato[], benefIndCancelContr: boolean) => {
    setBenefsToCancel(benefs);
    setIndCancelContr(benefIndCancelContr)
    fetchFormaEnvioConfirmacao(benefs);
  }

  const clearCityAndState = (postal: Address) => {
    let cleanedPostal = postal;
    cleanedPostal.cidade = undefined;
    cleanedPostal.estado = undefined;
    return postal;
  }

  const handleProceedThirdStep = (formaEnvioSelecionada: string, email?: string, postal?: Address) => {
    let postalBody: Address | {} = !!postal ? clearCityAndState(postal) : {};
    fetchTermoCancelamento(email, postalBody);
    setFormaEnvioSelecionada(formaEnvioSelecionada);
  }

  const handleProceedFourthStep = () => {
    executeContractCancel();
  }

  const executeContractCancel = async () => {
    setLoading(true);

    const lstIdUserContr: number[] = benefsToCancel.map(benef => benef.idUsrContr);

    const response = await passoFinalizacao(passoCartaCancelamento!.indRN195, formaEnvioSelecionada!, motivoSelecionado, lstIdUserContr, indCancelContr);
    if (response?.status === 200) {
      setProtocoloCancelamento(response.data);
      nextStep();
    } else {
      const errorMessage = !!response?.data.mensagem ? response.data.mensagem : 'Tente novamente em instantes';
      openModal('Erro ao efetivar cancelamento', errorMessage, handleCloseModalFeedback, handleCloseModalFeedback, 'Fechar', true);
      console.error(response);
    }
    setLoading(false);
  }

  const backToFirstStep = () => {
    setCurrentStep(CancellationStepsEnum.Motivo);
    setIsCancellationEmail(false);
  }

  const addPassoCartaCancelamentoEmail = (email: string) => {
    if (passoCartaCancelamento?.lstEmail?.find((endereco) => endereco.enderecoComunic === email)) return;

    let lstEmail = passoCartaCancelamento?.lstEmail as EnderComunicCancelamento[];
    lstEmail = lstEmail?.length ? [...lstEmail] : [];
    let maxIdEnderecoComunicacao = Math.max(...lstEmail.map((email) => Math.abs(email.idEnderecoComunicacao))) || 0;
    const newEndereco: EnderComunicCancelamento = {
      idEnderecoComunicacao: -maxIdEnderecoComunicacao - 1,
      tipoEnderecoComunicacao: "EMAIL",
      codigoClassificacaoEndereco: "PEP",
      enderecoComunic: email,
    };
    lstEmail.push(newEndereco);
    setPassoCartaCancelamento({ ...passoCartaCancelamento, lstEmail } as PassoCartaCancelamento);
  };

  const addPassoCartaCancelamentoAddress = (address: Address) => {
    let lstEndereco = passoCartaCancelamento?.lstEndereco as EnderecoCancelamento[];
    lstEndereco = lstEndereco?.length ? [...lstEndereco] : [];
    let maxIdEnderecoComunicacao = Math.max(...lstEndereco.map((endereco) => Math.abs(endereco.idEnderPostal))) || 0;
    const newEndereco = {
      logradouro: address.logradouro,
      numero: address.numero,
      complemento: address.complemento,
      bairro: address.bairro,
      cep: { cep: address.cep },
      cidade: { descrCidade: address.cidade, uf: { siglaUf: address.estado } },
      idEnderPostal: -maxIdEnderecoComunicacao - 1
    } as EnderecoCancelamento;
    lstEndereco.push(newEndereco);
    setPassoCartaCancelamento({ ...passoCartaCancelamento, lstEndereco } as PassoCartaCancelamento);
  };

  const StepMotivoAdvice = () => (
    <div className='cancellation-container'>
      <div style={{ ...contrastStyle, ...contrastBorderAccessibility }} className='cancellation-advice-container'>
        <Typography style={textStyleAccessibility} sx={sxDarkGreyBody}>
          <b>IMPORTANTE - Conforme RN561 –</b> Artigo II:  O cancelamento tem efeito imediato e caráter irrevogável da solicitação de cancelamento do contrato
          ou exclusão de beneficiário, a partir da ciência da operadora ou administradora de benefícios.
        </Typography>
      </div>
    </div>
  )

  return (
    <>
      <LoadingApp showLoading={loading} text={'Carregando...'} />
      <div className='cancellation-container'>
        <PageTitle text="Cancelamento de contrato ou de beneficiário(s)" />
        {currentStep === CancellationStepsEnum.Motivo && <StepMotivoAdvice />}
        {isPermissao &&
          <>
            <DefaultTabs
              step={currentStep - 1}
              stepLabels={cancellationSteps.map(s => s.label)}
              onTabClick={onTabClicked}
            />
            {currentStep === CancellationStepsEnum.Motivo &&
              <StepMotivoCancelamento
                motivosCancelamento={motivosCancelamento}
                toggleMotivoSelecionado={(motivo) => setMotivoSelecionado(motivo)}
                onProceed={handleProceedFirstStep}
                backStep={backStep}
                goToEmailStep={goToEmailStep}
                fetchMotivosCancelamento={fetchMotivosCancelamento}
                loading={loading}
              />}
            {currentStep === CancellationStepsEnum.Beneficiarios &&
              <StepBeneficiarios
                indProdutoCoop={motivosCancelamento?.indProdutoCoop!}
                tipoCancelamento={motivosCancelamento?.tipoCancelamento!}
                motivoCancelamento={motivoSelecionado}
                onProceed={handleProceedSecondStep}
                backStep={backStep}
                handlebenefsToCancel={handlebenefsToCancel}
              />}
            {currentStep === CancellationStepsEnum.CartaCancelamento &&
              <StepCartaCancelamento
                loading={loading}
                passoCartaCancelamento={passoCartaCancelamento}
                onProceed={handleProceedThirdStep}
                backStep={backStep}
                addPassoCartaCancelamentoEmail={addPassoCartaCancelamentoEmail}
                addPassoCartaCancelamentoAddress={addPassoCartaCancelamentoAddress}
              />}
            {currentStep === CancellationStepsEnum.Termos &&
              <StepTermos
                onProceed={handleProceedFourthStep}
                backStep={backStep}
                cancellationTerms={cancellationTerms!}
                benefsToCancel={benefsToCancel}
                tipoCancelamento={motivosCancelamento?.tipoCancelamento ?? 'CONTR'}
              />}
          </>
        }
        {(currentStep === CancellationStepsEnum.Finalizacao) &&
          <>
            {isCancellationEmail && <EnviarEmail goBack={backToFirstStep} />}
            {isRetencao && <EnviarRetencao motivoCancelamento={motivoSelecionado} benefs={benefsToCancel} tipoCancelamento={tipoCancelamento} />}
            {(!isCancellationEmail && !isRetencao) &&
              <StepFinalizacao
                backStep={() => navigate('/home')}
                cancelledBenefs={benefsToCancel}
                protocolo={protocoloCancelamento}
              />}
          </>
        }
      </div>
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default SolicitacaoCancelamento;